/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type { SunoWebhookRequest, SunoWebhookResponse } from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Suno API webhook callback handler
 */
export const webhooksSunoCallbackCreate = (
  sunoWebhookRequest: BodyType<SunoWebhookRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SunoWebhookResponse>(
    {
      url: `/webhooks/suno/callback/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: sunoWebhookRequest,
      signal,
    },
    options,
  );
};

export const getWebhooksSunoCallbackCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof webhooksSunoCallbackCreate>>,
    TError,
    { data: BodyType<SunoWebhookRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof webhooksSunoCallbackCreate>>,
  TError,
  { data: BodyType<SunoWebhookRequest> },
  TContext
> => {
  const mutationKey = ["webhooksSunoCallbackCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof webhooksSunoCallbackCreate>>,
    { data: BodyType<SunoWebhookRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return webhooksSunoCallbackCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WebhooksSunoCallbackCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof webhooksSunoCallbackCreate>>
>;
export type WebhooksSunoCallbackCreateMutationBody =
  BodyType<SunoWebhookRequest>;
export type WebhooksSunoCallbackCreateMutationError = ErrorType<unknown>;

export const useWebhooksSunoCallbackCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof webhooksSunoCallbackCreate>>,
      TError,
      { data: BodyType<SunoWebhookRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof webhooksSunoCallbackCreate>>,
  TError,
  { data: BodyType<SunoWebhookRequest> },
  TContext
> => {
  const mutationOptions = getWebhooksSunoCallbackCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
